import React, {Component} from "react";
import './TimeInput.scss'
class TimeInput extends Component {

  get desctructedValue() {
    let min = parseInt(this.props.value) || 0
    let hours = Math.floor(min/60);
    min = min - hours * 60;
    return {min: min || '', hours: hours || ''}
  }

  onInputHours(e) {
    const {min} = this.desctructedValue
    let hours = parseInt(e.target.value) || ''
    this.props.onInput(hours * 60 + min)
  }
  onInputMinutes(e) {
    const {hours} = this.desctructedValue
    let min = parseInt(e.target.value) || ''
    this.props.onInput(hours * 60 + min)
  }
  render() {
    const {hours, min} = this.desctructedValue
    return (
      <div className="time-input">
        <div className="time-segment">
          <span>Hours: </span>
          <input className="form-control" value={hours} onInput={(e) => this.onInputHours(e)} placeholder="Hours"/>

        </div>
        <div className="time-segment">
          <span>Minutes: </span>
          <input className="form-control" value={min} onInput={(e) => this.onInputMinutes(e)} placeholder="Minutes" />
        </div>
      </div>
    )
  }
}

export default TimeInput
